<div class="purchaseWrap section fix-bottom bg-white">
    <div class="sectionWrapper">
        <div class="powerzone">
            <div class="betInfoWrap">
                <div class="betInfo">
                    <div class="txt">{{userData?.panelData?.length}}</div>
                    <div class="label">{{'dge.totbet' | translate}}</div>
                </div>
                <div class="betInfo">
                    <div class="txt" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                    <div class="label">{{'dge.totbetval' | translate}}</div>
                </div>
            </div>
            <button class="buyNowBtn btn-primary" (click)="purchaseTicket()" [disabled]="calculateTotalPrice() == 0"
                [ngClass]="{'disabled':calculateTotalPrice() == 0}">
                {{'dge.buy' | translate}}
            </button>
        </div>
    </div>
</div>